module.exports = __webpack_public_path__ + "img/cadenza_allegro_light1.4386bf70.jpg";